import { createSlice } from "@reduxjs/toolkit";
import { ApplicationDetailsState } from "../types";
import { fetchApplicationDetails } from "./services/thunk/DetailsThunk";

const initialState: ApplicationDetailsState = {
  applicationDetails: null,
  loading: false,
  error: null,
};

const DetailsSlice = createSlice({
  name: "details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicationDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.applicationDetails = action.payload;
      })
      .addCase(fetchApplicationDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Something went wrong";
      });
  },
});

export default DetailsSlice.reducer;
